module.exports = __webpack_public_path__ + "static/media/unreal.fc3e1efd.svg";